import LanguageDialog from './LanguageDialog';

export default LanguageDialog;
